// extracted by mini-css-extract-plugin
module.exports = {"equalizer":"audioIcon_equalizer__8IWZf","bar":"audioIcon_bar__A2sZs","equalize":"audioIcon_equalize__zhJA9"};